export default __webpack_public_path__ + "static/media/mediumDeskMobile.c9e292ec.svg";